import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import PremiumBadge from "../Frequents/PremiumBadge.js";
import NewInvoice from "../Invoice/NewInvoice.js";
import SelectBoolean from "../Frequents/SelectBoolean.js";
import SimpleInput from "../Frequents/SimpleInput.js";
import ErrorMessage from "../Alerts/ErrorMessage.js";

export default props => {
    const therapist = useSelector(state => state.data.therapist);
    const [open, setOpen] = useState(false);
    const [type, setType] = useState(true);
    const [discount, setDiscount] = useState("");
    const [moms, setMoms] = useState(therapist.moms);
    const [treatmentText, setTreatmentText] = useState(true);
    const [aktuelBehandling, setAktuelBehandling] = useState(true);
    const [followUpText, setFollowUpText] = useState(true);
    const [dineroErrorMessages, setDineroErrorMessages] = useState([]);

    return (
        <>
            <Button
                variant="contained"
                style={{
                    backgroundColor: therapist.colors != null ? JSON.parse(therapist.colors)[1] : "",
                    color: therapist.plan === "pro" ? "#fff" : "black",
                    width: "100%"
                }}
                disabled={therapist.plan !== "pro"}
                onClick={event => {
                    if (therapist.plan === "pro") setOpen(true);
                    else event.preventDefault();
                }}>
                {therapist.plan === "pro" ? (
                    "Faktura"
                ) : (
                    <>
                        Faktura <PremiumBadge />
                    </>
                )}
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"lg"}>
                <DialogTitle id="form-dialog-title">Opret Faktura</DialogTitle>
                <DialogContent>
                    <SelectBoolean
                        text="Vælg type"
                        prop={type}
                        choice1="Faktura"
                        choice2="Kreditnota"
                        value1={true}
                        value2={false}
                        changeValue={setType}
                    />
                    <SimpleInput text="Rabat i DKK" type="number" prop={discount} changeValue={setDiscount} />
                    <SelectBoolean
                        text="Moms"
                        prop={moms}
                        choice1="Ja"
                        choice2="Nej"
                        value1={true}
                        value2={false}
                        changeValue={setMoms}
                    />
                    <SelectBoolean
                        text="Behandlingstekst"
                        prop={treatmentText}
                        choice1="Ja"
                        choice2="Nej"
                        value1={true}
                        value2={false}
                        changeValue={setTreatmentText}
                    />
                    <SelectBoolean
                        text="Aktuel behandling"
                        prop={aktuelBehandling}
                        choice1="Ja"
                        choice2="Nej"
                        value1={true}
                        value2={false}
                        changeValue={setAktuelBehandling}
                    />
                    <SelectBoolean
                        text="Opfølgningstekst"
                        prop={followUpText}
                        choice1="Ja"
                        choice2="Nej"
                        value1={true}
                        value2={false}
                        changeValue={setFollowUpText}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        Annuller
                    </Button>
                    <NewInvoice
                        close={() => setOpen(false)}
                        booking={props.booking}
                        type={type}
                        discount={Number(discount)}
                        moms={moms}
                        treatmentText={treatmentText}
                        aktuelBehandling={aktuelBehandling}
                        followUpText={followUpText}
                        dineroErrorMessages={dineroErrorMessages}
                        setDineroErrorMessages={setDineroErrorMessages}
                    />
                </DialogActions>
            </Dialog>
            {dineroErrorMessages.length ? (
                <ErrorMessage
                    open={true}
                    handleClose={() => setDineroErrorMessages([])}
                    text={dineroErrorMessages.map(message => {
                        return <p style={{ margin: 0 }}>{message}</p>;
                    })}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                />
            ) : null}
        </>
    );
};
